import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { ProgressCircle } from '@americanexpress/dls-react';
import {
  CARD_MEMBER,
  CARD_SELECTOR,
  THANK_YOU,
} from '../../utils/constants';

export const lazyImportedComponents = {
  [CARD_MEMBER]: lazy(() => import('../Journey/CardMember')),
  [CARD_SELECTOR]: lazy(() => import('../Journey/CardSelection')),
  [THANK_YOU]: lazy(() => import('../ThankYou')),
};

/**
 * Component to Load the components and its dependencies on demand
 * componentName is a required props to render the actual component.
 * lazyImportedComponents - components that are imported lazy.
*/
const LoadModuleInLazy = ({ componentName, ...props }) => {
  if (!componentName || !lazyImportedComponents[componentName]) {
    return null;
  }
  const Component = lazyImportedComponents[componentName];

  return (
    <Suspense
      fallback={<section id="spinner"><div className="pad flex flex-justify-center flex-align-items-center"><ProgressCircle size="lg" /></div></section>}
    >
      <Component {...props} />
    </Suspense>
  );
};

LoadModuleInLazy.propTypes = {
  componentName: PropTypes.string.isRequired,
};

export default LoadModuleInLazy;
